import moment from 'moment'

export const SET_ACTIVE_RESTAURANTS = 'SET_ACTIVE_RESTAURANTS'

export const setRestaurant = activeRestaurantData => ({
	type: SET_ACTIVE_RESTAURANTS,
	payload: activeRestaurantData
})

export default function setActiveRestaurants(venueId, reservationDate, activeReservationTime, activeReservationType, party, venueData) {
	return dispatch => {
		let activeRestaurantData = {},
				venueName = null

		// Set venue name based on feed data
		if (
			venueData &&
			venueData.title &&
			venueData.title.text
		) {
			venueName = venueData.title.text
		}

		// Create keyed active restaurant object - with all mandatory API fields
		activeRestaurantData[venueId] = {
			venueId: venueId,
			date: moment(reservationDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
			time: activeReservationTime,
			party: party,
			name: venueName,
			type: activeReservationType,
		}

		dispatch(setRestaurant(activeRestaurantData))
	}
}


// WEBPACK FOOTER //
// ./src/actions/setActiveRestaurants.js